export default "__VITE_ASSET__CgISD$om__"